import React, { useState } from "react";
import "./revenue.css";
import SourceInfoPopup from "./SourceInfoPopup";

export const ValueBadge = ({ v }) =>
  v ? <span className="m-value">{v}</span> : null;

export const SharePill = ({ pct }) =>
  pct == null ? null : <span className="m-share">({pct}%)</span>;

export function GrowthPill({ growthPct }) {
  if (growthPct === null || growthPct === undefined || Number.isNaN(Number(growthPct))) {
    return <span className="growth-pill growth-na">N/A</span>;
  }
  let cls = "growth-pill growth-blue"; // default

  if (growthPct > 15) cls = "growth-pill growth-green";
  else if (growthPct >= 10) cls = "growth-pill growth-blue";
  else if (growthPct > 0) cls = "growth-pill growth-orange";
  else cls = "growth-pill growth-red";

  // return <span className={cls}>{growthPct > 0 ? `+${growthPct}%` : `${growthPct}%`}</span>;
   return <span className={cls}></span>;
}

export function ValueSharePill({ value, sharePct }) {
  return (
    <div className="combined-pill">
      <span className="value">{value}</span>
      <span className="share">({sharePct}%)</span>
    </div>
  );
}

/** NEW: compact "(share)  +growth" in one capsule */
export const CombinedStatsPill = ({ sharePct, growthPct }) => {
  if (sharePct == null && growthPct == null) return null;
  const isPos = (growthPct ?? 0) > 0;
  const isNeg = (growthPct ?? 0) < 0;
  const cls = `m-combined ${isPos ? "pos" : isNeg ? "neg" : ""}`;
  const growthStr =
    growthPct == null ? "" : `${growthPct > 0 ? "+" : ""}${growthPct}%`;
  const shareStr = sharePct == null ? "" : `(${sharePct}%)`;
  return <span className={cls}>{shareStr}{growthStr ? `  ${growthStr}` : ""}</span>;
};

/** NEW: allow hiding the robot on nested rows */
 export const RowIcons = ({ showAI = false, onAIClick, sources = [], baseFacts = [], nodeLabel = "" }) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleInfoClick = (e) => {
    e.stopPropagation();
    setShowPopup(true);
  };

  return (
    <span className="row-icons">
      <span className="info-chip" title="Click to get more Info" onClick={handleInfoClick}>
        <i className="ri-question-line" style={{ cursor: "pointer" }} />
      </span>

      {showAI && (
        <img
          src="/img/ai_converation_green.png"
          alt="AI Insight"
          className="cardinal_filter_img"
          style={{ cursor: "pointer", width: 18, marginLeft: 6 }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onAIClick?.();
          }}
        />
      )}

      {showPopup && (
        <SourceInfoPopup
          sources={sources}
          baseFacts={baseFacts}
          nodeLabel={nodeLabel}
          onClose={() => setShowPopup(false)}
        />
      )}
    </span>
  );
};

